import { Button } from "@progress/kendo-react-buttons";
import React, { useEffect, useState } from "react";
import Input from "../../components/preview-input/input";
import FilterColors from "./filter-colors";
import FilterProfile from "./filter-profile";
import MainDetails from "./main-details";
import OrderProfile from "./order-profile";
import Story from "./story";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DrawingBox from "./drawing-box";
import Extensions from "./extensions";
import useOrderStore from "../../store/order-store";
import axiosInstance, { endpoints } from "../../utils/axios";
import Success from "../../components/success/success";
import { HOST_API } from "../../config-global";
import { convertErrorsToArray } from "../../utils/formats";
import { toast } from "react-toastify";
import axios from "axios";
import useResultStore from "../../store/result-store";
import { Loader } from "@progress/kendo-react-indicators";
import TableComponent from "../preview/table-component";
import { getDataForSf } from "./order-utils";

const OrderSheet = () => {
  const { id } = useParams();
  const { orderData, setFormData, reset } = useOrderStore();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const leadId = queryParams.get("leadId");
  const { resultData } = useResultStore();
  const [calculationData, setCalculationData] = useState({});
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [loading, setLoading] = useState(true);
  const [draftLoading, setDraftLoading] = useState(false);
  const [isDraft, setDraft] = useState(false);
  const [leadResultsDetail, setLeadResultDetails] = useState(null);
  const [leadDetails, setLeadDetails] = useState(null);

  const handleInputChange2 = (field) => (e) => {
    setFormData({
      ...orderData,
      [field]: e.target.value,
    });
  };
  useEffect(() => {
    getSheet();
    getleadDetails();
  }, []);
  const getleadDetails = async () => {
    try {
      const response = await axiosInstance.get(
        endpoints.leads.get_lead_detail(id)
      );
      if (response.data) {
        if (response.data.data?.results) {
          setLeadDetails(response.data.data);
          setLeadResultDetails({
            resultType: response.data.data?.results?.resultType,
            resultReason: response.data.data?.results?.resultReason,
            oneLeg: response.data.data?.results?.oneLeg,
            lastPrice: response.data.data?.results?.lastPrice,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching :", error);
    }
  };

  const getSheet = async () => {
    try {
      const response = await axiosInstance.get(
        endpoints.leads.get_order_detail(leadId)
      );
      if (response.data) {
        let data = response.data.data;
        setDraft(data.isDraft || false);
        const openingWidthValue = data?.gutterOpeningWidth?.find(
          (item) => !["4", "4.5", "5", "5.5", "6", "7", "8"].includes(item)
        );
        if (data.customer) {
          setShowButton(false);
          setFormData({
            ...data,
            partial: data.partial ? "Yes" : "No",
            existingProtection: data.existingProtection ? "Yes" : "No",
            roof: data.roof ? "Yes" : "No",
            csr_value: data?.csrValue,
            extensionsNeeded: data.extensionsNeeded ? "Yes" : "No",
            groundSpoutNeeded: data.groundSpoutNeeded ? "Yes" : "No",
            gutterOpeningWidth: data.gutterOpeningWidth,
            gutterOpeningWidthValue: openingWidthValue,
            existingProtectionTypeValue: data.existingProtection
              ? data.existingProtectionTypeValue
              : 0,
            walkboards: data.walkboards ? "Yes" : "No",
            roofType:
              data.roofType != "Flat Roof" &&
              data.roofType != "Wood Shake" &&
              data.roofType != "Asphalt Shingle" &&
              data.roofType != "Metal" &&
              data.roofType != "Tile" &&
              data.roofType != "Slate"
                ? "Other"
                : data.roofType,
            roofTypeValue:
              data.roofType != "Flat Roof" &&
              data.roofType != "Wood Shake" &&
              data.roofType != "Asphalt Shingle" &&
              data.roofType != "Metal" &&
              data.roofType != "Tile" &&
              data.roofType != "Slate"
                ? data.roofType
                : "",
            ladders:
              data.ladders != "8" &&
              data.ladders != "10" &&
              data.ladders != "24" &&
              data.ladders != "28" &&
              data.ladders != "32" &&
              data.ladders != "40"
                ? "Other"
                : data?.ladders?.toString(),
            laddersValue:
              data.ladders != "8" &&
              data.ladders != "10" &&
              data.ladders != "24" &&
              data.ladders != "28" &&
              data.ladders != "32" &&
              data.ladders != "40"
                ? data.ladders
                : "",
            job: leadId,
            versa_max_quantity: data.versaMaxValue,
            hasSheet: true,
          });
          setLoading(false);
        } else {
          // reset();
          setShowButton(true);
          setFormData({
            ...orderData,
            hasSheet: false,
          });
          setLoading(false);
        }
      }
    } catch (error) {
      console.error("Error fetching :", error);
    }
  };
  function removeEmptyStrings(obj) {
    for (const key in obj) {
      if (obj[key] === "") {
        delete obj[key];
      }
    }
    return obj;
  }
  function convertEmptyStringsToZero(data) {
    if (Array.isArray(data)) {
      data.forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (Array.isArray(item[key])) {
            item[key] = item[key].map((value) => (value === "" ? 0 : value));
          }
        });
      });
    }
    return data;
  }
  function convertInvalidValuesToZero(data) {
    if (Array.isArray(data)) {
      data.forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (Array.isArray(item[key])) {
            item[key] = item[key].map((value) =>
              value === "" || value === null ? 0 : value
            );
          }
        });
      });
    }
    return data;
  }

  function replaceNullWithEmptyString(obj) {
    for (const key in obj) {
      if (obj[key] === null) {
        obj[key] = ""; // Replace null with an empty string
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        // Skip objects without modifying them
        continue;
      }
    }
    return obj;
  }

  const onSubmit = async (url, draft) => {
    if (resultData.lastPrice == "") {
      resultData.lastPrice = 0;
    }
    resultData.resultType =
      resultData.resultType || leadResultsDetail.resultType || "Demo";
    resultData.resultReason =
      resultData.resultReason || leadResultsDetail.resultReason || "";
    resultData.oneLeg = resultData.oneLeg || leadResultsDetail.oneLeg || "mr";
    resultData.lastPrice =
      resultData.lastPrice || leadResultsDetail.lastPrice || 0;
    let finnnalWidths = orderData.gutterOpeningWidthValue
      ? [
          ...orderData.gutterOpeningWidth,
          orderData.gutterOpeningWidthValue.toString(),
        ]
      : orderData.gutterOpeningWidth;
    const subdata = {
      ...orderData,
      partial: orderData.partial == "Yes" ? true : false,
      existingProtection: orderData.existingProtection == "Yes" ? true : false,
      existingProtectionType:
        orderData.existingProtection == "Yes" &&
        orderData.existingProtectionType,
      existingProtectionTypeValue:
        orderData.existingProtection === "Yes"
          ? Number(orderData.existingProtectionTypeValue)
          : 0,
      roof: orderData.roof == "Yes" ? true : false,
      extensionsNeeded: orderData.extensionsNeeded == "Yes" ? true : false,
      groundSpoutNeeded: orderData.groundSpoutNeeded == "Yes" ? true : false,
      walkboards: orderData.walkboards == "Yes" ? true : false,
      csrValue: orderData?.csr_value?.toString() || "",
      gutterOpeningWidth: finnnalWidths,
      roofType:
        orderData.roofType == "Other"
          ? orderData.roofTypeValue
          : orderData.roofType,
      ladders:
        orderData.ladders == "Other"
          ? orderData.laddersValue
          : orderData.ladders,
      leadId: leadId,
      results: resultData,
      totalFootage: orderData?.totalFootage?.toString(),
      versaMaxValue: orderData.leafFilterProfile.includes("Versa Max")
        ? orderData?.versa_max_quantity?.toString() || ""
        : "",
    };

    delete subdata.images;
    delete subdata.gutterOpeningWidthValue;

    let customSubdata = replaceNullWithEmptyString(subdata);

    customSubdata.existingProtectionTypeValue =
      customSubdata?.existingProtectionTypeValue
        ? Number(customSubdata.existingProtectionTypeValue)
        : 0;
    const sfData = removeEmptyStrings(subdata);
    sfData.measurements = convertEmptyStringsToZero(sfData.measurements);
    sfData.sizes = convertInvalidValuesToZero(sfData.sizes);
    sfData.versaMaxValue = Number(sfData.versaMaxValue) || 0;
    const genrateDataForSf = getDataForSf(sfData);
    genrateDataForSf.retailPrice =
      (genrateDataForSf?.retailPricing?.firstStoryTotal1 || 0) +
      (genrateDataForSf?.retailPricing?.firstStoryTotal2 || 0) +
      (genrateDataForSf?.retailPricing?.secondStoryTotal1 || 0) +
      (genrateDataForSf?.retailPricing?.secondStoryTotal2 || 0) +
      (genrateDataForSf?.retailPricing?.thirdStoryTotal1 || 0) +
      (genrateDataForSf?.retailPricing?.thirdStoryTotal2 || 0) +
      (genrateDataForSf?.retailPricing?.firstStoryRAndRTotal1 || 0) +
      (genrateDataForSf?.retailPricing?.firstStoryRAndRTotal2 || 0) +
      (genrateDataForSf?.retailPricing?.secondStoryRAndRTotal1 || 0) +
      (genrateDataForSf?.retailPricing?.secondStoryRAndRTotal2 || 0) +
      (genrateDataForSf?.retailPricing?.thirdStoryRAndRTotal1 || 0) +
      (genrateDataForSf?.retailPricing?.thirdStoryRAndRTotal2 || 0) +
      (genrateDataForSf?.retailPricing?.versaMaxQuantity || 0) +
      (genrateDataForSf?.retailPricing?.fatnerType || 0) +
      (genrateDataForSf?.retailPricing?.cleanSealReinforce || 0) +
      (genrateDataForSf?.retailPricing?.ofInsideCorners || 0) +
      (genrateDataForSf?.retailPricing?.ofOutSideCorners || 0) +
      (genrateDataForSf?.retailPricing?.type || 0) +
      (genrateDataForSf?.retailPricing?.extensionsNeededFootage || 0) +
      (genrateDataForSf?.retailPricing?.units || 0) +
      (genrateDataForSf?.retailPricing?.ofAElbows || 0) +
      (genrateDataForSf?.retailPricing?.ofBElbows || 0) +
      (genrateDataForSf?.retailPricing?.sizes?.reduce(
        (total, item) =>
          total +
          (item.values?.reduce((subTotal, num) => subTotal + num, 0) || 0),
        0
      ) || 0) +
      500;
    genrateDataForSf.parPrice =
      ((genrateDataForSf?.retailPricing?.firstStoryTotal1 || 0) +
        (genrateDataForSf?.retailPricing?.firstStoryTotal2 || 0) +
        (genrateDataForSf?.retailPricing?.secondStoryTotal1 || 0) +
        (genrateDataForSf?.retailPricing?.secondStoryTotal2 || 0) +
        (genrateDataForSf?.retailPricing?.thirdStoryTotal1 || 0) +
        (genrateDataForSf?.retailPricing?.thirdStoryTotal2 || 0) +
        (genrateDataForSf?.retailPricing?.firstStoryRAndRTotal1 || 0) +
        (genrateDataForSf?.retailPricing?.firstStoryRAndRTotal2 || 0) +
        (genrateDataForSf?.retailPricing?.secondStoryRAndRTotal1 || 0) +
        (genrateDataForSf?.retailPricing?.secondStoryRAndRTotal2 || 0) +
        (genrateDataForSf?.retailPricing?.thirdStoryRAndRTotal1 || 0) +
        (genrateDataForSf?.retailPricing?.thirdStoryRAndRTotal2 || 0) +
        (genrateDataForSf?.retailPricing?.versaMaxQuantity || 0) +
        (genrateDataForSf?.retailPricing?.fatnerType || 0) +
        (genrateDataForSf?.retailPricing?.cleanSealReinforce || 0) +
        (genrateDataForSf?.retailPricing?.ofInsideCorners || 0) +
        (genrateDataForSf?.retailPricing?.ofOutSideCorners || 0) +
        (genrateDataForSf?.retailPricing?.type || 0) +
        (genrateDataForSf?.retailPricing?.extensionsNeededFootage || 0) +
        (genrateDataForSf?.retailPricing?.units || 0) +
        (genrateDataForSf?.retailPricing?.ofAElbows || 0) +
        (genrateDataForSf?.retailPricing?.ofBElbows || 0) +
        (genrateDataForSf?.retailPricing?.sizes?.reduce(
          (total, item) =>
            total +
            (item.values?.reduce((subTotal, num) => subTotal + num, 0) || 0),
          0
        ) || 0) +
        500) *
      0.65;
    genrateDataForSf.costPrice =
      (genrateDataForSf?.costPricing?.firstStoryTotal1 || 0) +
      (genrateDataForSf?.costPricing?.firstStoryTotal2 || 0) +
      (genrateDataForSf?.costPricing?.secondStoryTotal1 || 0) +
      (genrateDataForSf?.costPricing?.secondStoryTotal2 || 0) +
      (genrateDataForSf?.costPricing?.thirdStoryTotal1 || 0) +
      (genrateDataForSf?.costPricing?.thirdStoryTotal2 || 0) +
      (genrateDataForSf?.costPricing?.firstStoryRAndRTotal1 || 0) +
      (genrateDataForSf?.costPricing?.firstStoryRAndRTotal2 || 0) +
      (genrateDataForSf?.costPricing?.secondStoryRAndRTotal1 || 0) +
      (genrateDataForSf?.costPricing?.secondStoryRAndRTotal2 || 0) +
      (genrateDataForSf?.costPricing?.thirdStoryRAndRTotal1 || 0) +
      (genrateDataForSf?.costPricing?.thirdStoryRAndRTotal2 || 0) +
      (genrateDataForSf?.costPricing?.versaMaxQuantity || 0) +
      (genrateDataForSf?.costPricing?.fatnerType || 0) +
      (genrateDataForSf?.costPricing?.cleanSealReinforce || 0) +
      (genrateDataForSf?.costPricing?.ofInsideCorners || 0) +
      (genrateDataForSf?.costPricing?.ofOutSideCorners || 0) +
      (genrateDataForSf?.costPricing?.type || 0) +
      (genrateDataForSf?.costPricing?.extensionsNeededFootage || 0) +
      (genrateDataForSf?.costPricing?.units || 0) +
      (genrateDataForSf?.costPricing?.ofAElbows || 0) +
      (genrateDataForSf?.costPricing?.ofBElbows || 0) +
      (genrateDataForSf?.costPricing?.sizes?.reduce(
        (total, item) =>
          total +
          (item.values?.reduce((subTotal, num) => subTotal + num, 0) || 0),
        0
      ) || 0);
    genrateDataForSf.costPricing.totalFootage =
      genrateDataForSf?.costPricing?.firstStoryTotal1 +
      genrateDataForSf?.costPricing?.firstStoryTotal2 +
      genrateDataForSf?.costPricing?.secondStoryTotal1 +
      genrateDataForSf?.costPricing?.secondStoryTotal2 +
      genrateDataForSf?.costPricing?.thirdStoryTotal1 +
      genrateDataForSf?.costPricing?.thirdStoryTotal2;
    genrateDataForSf.retailPricing.totalFootage =
      genrateDataForSf?.retailPricing?.firstStoryTotal1 +
      genrateDataForSf?.retailPricing?.firstStoryTotal2 +
      genrateDataForSf?.retailPricing?.secondStoryTotal1 +
      genrateDataForSf?.retailPricing?.secondStoryTotal2 +
      genrateDataForSf?.retailPricing?.thirdStoryTotal1 +
      genrateDataForSf?.retailPricing?.thirdStoryTotal2;

    setCalculationData(genrateDataForSf);

    // const result = await salesForceLogin(genrateDataForSf);
    // return;
    customSubdata.versaMaxValue =
      customSubdata?.versaMaxValue !== undefined &&
      customSubdata?.versaMaxValue !== null
        ? String(customSubdata.versaMaxValue)
        : "";
    customSubdata.existingProtectionType = !customSubdata?.existingProtection
      ? ""
      : customSubdata.existingProtectionType;
    try {
      const response = await axios.post(
        url,
        {
          ...customSubdata,
          retailPricing: genrateDataForSf?.retailPricing,
          costPricing: genrateDataForSf?.costPricing,
          parPrice: genrateDataForSf?.parPrice,
          costPrice: genrateDataForSf?.costPrice,
          RetailPrice: genrateDataForSf?.retailPrice,
          images: orderData.images || [],
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            "Content-Type": "application/json",
          },
        }
      );
      const sfData = removeEmptyStrings(subdata);
      sfData.measurements = convertEmptyStringsToZero(sfData.measurements);
      sfData.sizes = convertInvalidValuesToZero(sfData.sizes);
      sfData.versaMaxValue = Number(sfData.versaMaxValue) || 0;

      setShowSuccess(true);
      setLoading(false);
      setDraftLoading(false);
      setTimeout(() => {
        setShowSuccess(false);
        navigate(`/leads/${id}`);
      }, 2000);
    } catch (error) {
      setDraftLoading(false);
      setLoading(false);
      // console.error("Error submitting data:", error?.response?.data?.data);
      const errorsArray = convertErrorsToArray(error?.response?.data?.data);

      if (errorsArray.length > 0) {
        errorsArray.forEach((err) => toast.error(err));
      } else if (error.message) {
        toast.error(error.message);
      } else {
        toast.error("Internal Server Error");
      }
    }
  };

  return (
    <div className="">
      <h2 className="k-py-4 k-font-bold">Preview</h2>
      <div className="k-rounded-lg k-p-4" style={{ background: "#FFFFFF" }}>
        <div
          className=" k-border-solid k-border k-border-black k-sm-w-100"
          style={{ width: "30%" }}
        >
          <h2 className="k-m-0 k-py-3 k-px-3">LeafFilter Order Sheet</h2>
        </div>
        <div className="k-border-solid k-border k-border-black k-mt-1">
          <MainDetails id={id} />
        </div>
        <div className="k-border-solid k-border k-border-black">
          <OrderProfile />
        </div>
        <div className="k-border-solid k-border k-border-black">
          <FilterProfile />
        </div>
        <div className="k-px-2 k-border-solid k-border k-border-black  k-d-grid k-grid-cols-2 k-grid-sm-cols-1">
          <Story />

          <FilterColors />
        </div>

        <div className="k-px-2 k-border-solid k-border k-border-black k-d-grid k-grid-cols-2 k-grid-sm-cols-1">
          <Extensions />

          {/* second next section */}
          <DrawingBox type="order"/>
        </div>
        <div className=" k-px-2 k-border-solid k-border k-border-black">
          <h4 className="k-m-0 k-p-3 k-display-flex k-gap-2">
            <u>Note: </u>
            <Input
              value={orderData.note}
              onChange={handleInputChange2("note")}
            />
          </h4>
        </div>
      </div>
      {!leadDetails?.mhalt ? (
        <div className="k-w-full k-d-flex k-justify-content-end k-my-8">
          <Button
            onClick={() => navigate(`/leads/${id}`)}
            primary={true}
            className="k-button-red2 k-mr-2"
            size="large"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setDraftLoading(true);
              onSubmit(`${HOST_API}${endpoints.leads.post_order_draft}`, true);
            }}
            primary={true}
            className="k-button k-mr-2"
            size="large"
            style={{ width: 130 }}
          >
            {draftLoading ? (
              <Loader
                size="small"
                type="converging-spinner"
                style={{ color: "black" }}
              />
            ) : (
              "Save As Draft"
            )}
          </Button>
          <Button
            style={{ width: 130 }}
            onClick={() => {
              setLoading(true);
              onSubmit(`${HOST_API}${endpoints.leads.post_order}`);
            }}
            primary={true}
            className="k-button-green"
            size="large"
          >
            {loading ? (
              <Loader
                size="small"
                type="converging-spinner"
                style={{ color: "white" }}
              />
            ) : (
              "Submit"
            )}
          </Button>
        </div>
      ) : (
        <div className="k-w-full k-d-flex k-justify-content-end k-my-8">
          {/* <Button
            // onClick={onSubmit}
            onClick={() => navigate(`/leads/${id}`)}
            primary={true}
            className="k-button k-mr-2"
            size="large"
          >
            Go Back
          </Button> */}
        </div>
      )}
      {showSuccess && (
        <Success
          visible={showSuccess}
          toggleDialog={() => setShowSuccess(false)}
        />
      )}
    </div>
  );
};

export default OrderSheet;
